import React from "react";
import {formatMoney2} from "utils/moneyHelper";
import {InnerTable} from "../styles/SubCompanyInvoice.styles";

const columns = [
    {title: "Referans Kod", dataIndex: "referenceCode"},
    {
        title: "Referans Bitiş Tarihi",
        dataIndex: "dueDate",
        render: date => (date ? new Date(date).toLocaleDateString("tr-TR") : "-")
    },
    {
        title: "Fatura Tutarı",
        dataIndex: "amount",
        render: amount => formatMoney2({amount, currency: "TL"})
    },
    {title: "Toplam İşlem Adedi", dataIndex: "transactionCount"}
];

export const CodInvoiceTable = ({invoices}) => (
    <InnerTable
        $variant="cod"
        size="small"
        columns={columns}
        dataSource={invoices}
        rowKey="referenceCode"
        pagination={false}
        locale={{emptyText: "Kesilmesi beklenen cod faturası bulunamadı."}}
    />
);
